const images = {
    'journeys': {
        'offer1': [
            require('./journeys/offer1/journeys_offer1_img.jpg'),
        ],
        'offer2': [
            require('./journeys/offer2/journeys_offer2_img.jpg'),
        ],
        'offer3': [
            require('./journeys/offer3/journeys_offer3_img.jpg'),
        ],
        'offer4': [
            require('./journeys/offer4/journeys_offer4_img.jpg'),
        ],
        'offer5': [
            require('./journeys/offer5/journeys_offer5_img.jpg'),
        ],
        'offer6': [
            require('./journeys/offer6/journeys_offer6_img.jpg'),
        ],
        'offer7': [
            require('./journeys/offer7/journeys_offer7_img.jpg'),
        ],
        'offer8': [
            require('./journeys/offer8/journeys_offer8_img.jpg'),
        ],
        'offer9': [
            require('./journeys/offer9/journeys_offer9_img.jpg'),
        ],
        'offer10': [
            require('./journeys/offer10/journeys_offer10_img.jpg'),
        ],
        'offer11': [
            require('./journeys/offer11/journeys_offer11_img.jpg'),
        ],
        'offer12': [
            require('./journeys/offer12/journeys_offer12_img.jpg'),
        ],
        'offer13': [
            require('./journeys/offer13/journeys_offer13_img.jpg'),
        ],
        'offer14': [
            require('./journeys/offer14/journeys_offer14_img.jpg'),
        ],
        'offer15': [
            require('./journeys/offer15/journeys_offer15_img.jpg'),
        ],
        'offer16': [
            require('./journeys/offer16/journeys_offer16_img.jpg'),
        ],
        'offer17': [
            require('./journeys/offer17/journeys_offer17_img.jpg'),
        ],
        'offer18': [
            require('./journeys/offer18/journeys_offer18_img.jpg'),
        ],
        'offer19': [
            require('./journeys/offer19/journeys_offer19_img.jpg'),
        ],
        'offer20': [
            require('./journeys/offer20/journeys_offer20_img.jpg'),
        ]        
    },
    'tastemakers': {
        'offer1': [
            require('./tastemakers/offer1/tastemakers_offer1_img.jpg'),
        ],
        'offer2': [
            require('./tastemakers/offer2/tastemakers_offer2_img.jpg'),
        ],
        'offer3': [
            require('./tastemakers/offer3/tastemakers_offer3_img.jpg'),
        ],
        'offer4': [
            require('./tastemakers/offer4/tastemakers_offer4_img.jpg'),
        ],
        'offer5': [
            require('./tastemakers/offer5/tastemakers_offer5_img.jpg'),
        ],
        'offer6': [
            require('./tastemakers/offer6/tastemakers_offer6_img.jpg'),
        ],
        'offer7': [
            require('./tastemakers/offer7/tastemakers_offer7_img.jpg'),
        ],
        'offer8': [
            require('./tastemakers/offer8/tastemakers_offer8_img.jpg'),
        ],
        'offer9': [
            require('./tastemakers/offer9/tastemakers_offer9_img.jpg'),
        ],
        'offer10': [
            require('./tastemakers/offer10/tastemakers_offer10_img.jpg'),
        ],
        'offer11': [
            require('./tastemakers/offer11/tastemakers_offer11_img.jpg'),
        ],
        'offer12': [
            require('./tastemakers/offer12/tastemakers_offer12_img.jpg'),
        ],
        'offer13': [
            require('./tastemakers/offer13/tastemakers_offer13_img.jpg'),
        ],
        'offer14': [
            require('./tastemakers/offer14/tastemakers_offer14_img.jpg'),
        ],
        'offer15': [
            require('./tastemakers/offer15/tastemakers_offer15_img.jpg'),
        ],
        'offer16': [
            require('./tastemakers/offer16/tastemakers_offer16_img.jpg'),
        ],
        'offer17': [
            require('./tastemakers/offer17/tastemakers_offer17_img.jpg'),
        ],
        'offer18': [
            require('./tastemakers/offer18/tastemakers_offer18_img.jpg'),
        ],
        'offer19': [
            require('./tastemakers/offer19/tastemakers_offer19_img.jpg'),
        ],
        'offer20': [
            require('./tastemakers/offer20/tastemakers_offer20_img.jpg'),
        ]        
    },
    'balance': {
        'offer1': [
            require('./balance/offer1/balance_offer1_img.jpg'),
        ],
        'offer2': [
            require('./balance/offer2/balance_offer2_img.jpg'),
        ],
        'offer3': [
            require('./balance/offer3/balance_offer3_img.jpg'),
        ],
        'offer4': [
            require('./balance/offer4/balance_offer4_img.jpg'),
        ],
        'offer5': [
            require('./balance/offer5/balance_offer5_img.jpg'),
        ],
        'offer6': [
            require('./balance/offer6/balance_offer6_img.jpg'),
        ],
        'offer7': [
            require('./balance/offer7/balance_offer7_img.jpg'),
        ],
        'offer8': [
            require('./balance/offer8/balance_offer8_img.jpg'),
        ],
        'offer9': [
            require('./balance/offer9/balance_offer9_img.jpg'),
        ],
        'offer10': [
            require('./balance/offer10/balance_offer10_img.jpg'),
        ],
        'offer11': [
            require('./balance/offer11/balance_offer11_img.jpg'),
        ],
        'offer12': [
            require('./balance/offer12/balance_offer12_img.jpg'),
        ],
        'offer13': [
            require('./balance/offer13/balance_offer13_img.jpg'),
        ],
        'offer14': [
            require('./balance/offer14/balance_offer14_img.jpg'),
        ],
        'offer15': [
            require('./balance/offer15/balance_offer15_img.jpg'),
        ],
        'offer16': [
            require('./balance/offer16/balance_offer16_img.jpg'),
        ],
        'offer17': [
            require('./balance/offer17/balance_offer17_img.jpg'),
        ],
        'offer18': [
            require('./balance/offer18/balance_offer18_img.jpg'),
        ],
        'offer19': [
            require('./balance/offer19/balance_offer19_img.jpg'),
        ],
        'offer20': [
            require('./balance/offer20/balance_offer20_img.jpg'),
        ]        
    },
    'moments': {
        'offer1': [
            require('./moments/offer1/moments_offer1_img.jpg'),
        ],
        'offer2': [
            require('./moments/offer2/moments_offer2_img.jpg'),
        ],
        'offer3': [
            require('./moments/offer3/moments_offer3_img.jpg'),
        ],
        'offer4': [
            require('./moments/offer4/moments_offer4_img.jpg'),
        ],
        'offer5': [
            require('./moments/offer5/moments_offer5_img.jpg'),
        ],
        'offer6': [
            require('./moments/offer6/moments_offer6_img.jpg'),
        ],
        'offer7': [
            require('./moments/offer7/moments_offer7_img.jpg'),
        ],
        'offer8': [
            require('./moments/offer8/moments_offer8_img.jpg'),
        ],
        'offer9': [
            require('./moments/offer9/moments_offer9_img.jpg'),
        ],
        'offer10': [
            require('./moments/offer10/moments_offer10_img.jpg'),
        ],
        'offer11': [
            require('./moments/offer11/moments_offer11_img.jpg'),
        ],
        'offer12': [
            require('./moments/offer12/moments_offer12_img.jpg'),
        ],
        'offer13': [
            require('./moments/offer13/moments_offer13_img.jpg'),
        ],
        'offer14': [
            require('./moments/offer14/moments_offer14_img.jpg'),
        ],
        'offer15': [
            require('./moments/offer15/moments_offer15_img.jpg'),
        ],
        'offer16': [
            require('./moments/offer16/moments_offer16_img.jpg'),
        ],
        'offer17': [
            require('./moments/offer17/moments_offer17_img.jpg'),
        ],
        'offer18': [
            require('./moments/offer18/moments_offer18_img.jpg'),
        ],
        'offer19': [
            require('./moments/offer19/moments_offer19_img.jpg'),
        ],
        'offer20': [
            require('./moments/offer20/moments_offer20_img.jpg'),
        ]        
    },
    'delights': {
        'offer1': [
            require('./delights/offer1/delights_offer1_img.jpg'),
        ],
        'offer2': [
            require('./delights/offer2/delights_offer2_img.jpg'),
        ],
        'offer3': [
            require('./delights/offer3/delights_offer3_img.jpg'),
        ],
        'offer4': [
            require('./delights/offer4/delights_offer4_img.jpg'),
        ],
        'offer5': [
            require('./delights/offer5/delights_offer5_img.jpg'),
        ],
        'offer6': [
            require('./delights/offer6/delights_offer6_img.jpg'),
        ],
        'offer7': [
            require('./delights/offer7/delights_offer7_img.jpg'),
        ],
        'offer8': [
            require('./delights/offer8/delights_offer8_img.jpg'),
        ],
        'offer9': [
            require('./delights/offer9/delights_offer9_img.jpg'),
        ],
        'offer10': [
            require('./delights/offer10/delights_offer10_img.jpg'),
        ],
        'offer11': [
            require('./delights/offer11/delights_offer11_img.jpg'),
        ],
        'offer12': [
            require('./delights/offer12/delights_offer12_img.jpg'),
        ],
        'offer13': [
            require('./delights/offer13/delights_offer13_img.jpg'),
        ],
        'offer14': [
            require('./delights/offer14/delights_offer14_img.jpg'),
        ],
        'offer15': [
            require('./delights/offer15/delights_offer15_img.jpg'),
        ],
        'offer16': [
            require('./delights/offer16/delights_offer16_img.jpg'),
        ],
        'offer17': [
            require('./delights/offer17/delights_offer17_img.jpg'),
        ],
        'offer18': [
            require('./delights/offer18/delights_offer18_img.jpg'),
        ],
        'offer19': [
            require('./delights/offer19/delights_offer19_img.jpg'),
        ],
        'offer20': [
            require('./delights/offer20/delights_offer20_img.jpg'),
        ]        
    },
    'rewards': {
        'offer1': [
            require('./rewards/offer1/rewards_offer1_img.jpg'),
        ]
    },
    
}

export default images;